// V4 "Continuous Chromatic Scientific System" — per-category surface gradients.
// Derived from config/theme_tokens_v4.json. All homepage sections stay in the dark-to-mid
// luminance family; color identity comes from hue shifts, ambient glows and motifs — never from
// switching to near-white. White/paper is reserved for document/SOP artifacts (.doc-paper) only.

// Homepage scroll order (top → bottom). Used to blend each section's top edge from the
// previous section's end color so transitions are smooth hand-offs, not hard cuts.
export const SECTION_FLOW = [
  "overview", "impact", "pillars", "projects", "rca", "ci", "qms",
  "automation", "iot", "analytics", "productQuality", "expertise", "about", "contact",
];

// [from, via, to] vertical gradient stops per flow key.
export const SURFACES = {
  overview: ["#07111F", "#0B1A2B", "#0B2730"],
  impact: ["#0A1626", "#0B1B2C", "#0C2231"],
  pillars: ["#0A1828", "#0C1F31", "#0E2436"],
  projects: ["#0B1A2B", "#10243A", "#112D45"],
  rca: ["#241B20", "#332128", "#3A2924"],
  ci: ["#102724", "#16352D", "#1C4035"],
  qms: ["#211D35", "#2D2547", "#32305A"],
  automation: ["#091B2D", "#0B2940", "#0D3446"],
  iot: ["#101C31", "#172540", "#24234A"],
  analytics: ["#0D1D35", "#112B4B", "#133854"],
  productQuality: ["#0C2228", "#10332F", "#173A33"],
  expertise: ["#14252D", "#1C303A", "#282B45"],
  about: ["#10242B", "#153139", "#17373D"],
  contact: ["#0C1B24", "#0E2028", "#12262C"],
};

// Map each CategoryBackground variant to its flow/surface key.
export const VARIANT_SURFACE = {
  hero: "overview",
  blueprint: "projects",
  quality: "productQuality",
  pareto: "rca",
  pdca: "ci",
  lifecycle: "qms",
  pipeline: "automation",
  mesh: "iot",
  scatter: "analytics",
  lattice: "expertise",
  precision: "about",
  impact: "impact",
  pillars: "pillars",
  contact: "contact",
};

// Vertical base gradient for a flow key. The top ~150px blends from the previous section's
// end color into this section's start color, producing a smooth chromatic hand-off.
export function surfaceGradient(flowKey) {
  const i = SECTION_FLOW.indexOf(flowKey);
  const [from, via, to] = SURFACES[flowKey] || SURFACES.overview;
  const prevTo = i > 0 ? SURFACES[SECTION_FLOW[i - 1]][2] : from;
  return `linear-gradient(180deg, ${prevTo} 0px, ${from} 150px, ${via} 52%, ${to} 100%)`;
}
